import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Birthday } from '../../../models/Birthday';
import { BirthdaysService } from '../../../services/Birthdays.service';
import { showSnackbarAlert } from '../../../store/slicers/snackbarAlert.slicer';
import { checkResponseStatus } from '../../../utils/api/response';
import { BirthdayCard } from '../BirthdayCard/BirthdayCard';

export const BirthdaysComponent = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [birthdays, setBirthdays] = useState<Birthday[]>([]);

  const fetchBirthdays = async () => {
    try {
      setLoading(true);
      const response = await BirthdaysService.getBirthdays();
      if (response && checkResponseStatus(response)) {
        setBirthdays(response.data);
      }
    } catch (error: any) {
      dispatch(showSnackbarAlert({ message: 'Erro ao buscar aniversariantes', severity: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBirthdays();
  }, []);

  if (loading) return null;

  return (
    <Card>
      <CardHeader title={<Typography variant="h5">Aniversariantes da Semana</Typography>} />
      <Divider />
      <CardContent>
        {birthdays.map((birthday, index) => (
          <Fragment key={index}>
            <BirthdayCard birthday={birthday} />
            <Divider />
          </Fragment>
        ))}
      </CardContent>
    </Card>
  );
};
